import { render, staticRenderFns } from "./VClock.vue?vue&type=template&id=27baffa1&"
import script from "./VClock.vue?vue&type=script&lang=js&"
export * from "./VClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports